(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["acc-errors"] && !Shopify.designMode) return;
  try {
    /* After a failed submit Shopify draws the page again without a #hash. Move focus to the summary, or to the first field
     with an error when the form shows no summary, so screen reader and keyboard users land on the problem. */
  (() => {
    const focusProblem = () => {
      let target = document.querySelector('[data-acc-summary]');
      if (!target) {
        target = Array.from(document.querySelectorAll('.acc-card [aria-invalid="true"]')).find((el) => el.getClientRects().length > 0) || null;
      }
      if (target instanceof HTMLElement) target.focus();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusProblem, { once: true });
    else focusProblem();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["acc-field"] && !Shopify.designMode) return;
  try {
    /* Show or hide the typed password. The button is a toggle: its label stays the same and aria-pressed changes. */
  class AccPassword extends HTMLElement {
    connectedCallback() {
      // one listener on the element, so it works even when the children are parsed after the element is created
      this.addEventListener('click', (event) => {
        const button = event.target instanceof Element ? event.target.closest('.acc-pw__btn') : null;
        const input = this.querySelector('input');
        if (!button || !input) return;
        const show = input.type === 'password';
        input.type = show ? 'text' : 'password';
        button.setAttribute('aria-pressed', String(show));
      });
    }
  }
  if (!customElements.get('acc-password')) customElements.define('acc-password', AccPassword);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lead-script"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lead-form')) {
    const store = {
      get(key) {
        try {
          const raw = window.sessionStorage.getItem(key);
          return raw ? JSON.parse(raw) : null;
        } catch (error) {
          return null;
        }
      },
      set(key, value) {
        try {
          window.sessionStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
          /* private mode: the form still works */
        }
      },
      remove(key) {
        try {
          window.sessionStorage.removeItem(key);
        } catch (error) {
          /* private mode */
        }
      },
    };

    const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const lcfirst = (text) => (text ? text.charAt(0).toLowerCase() + text.slice(1) : text);
    const hostOf = (url) => url.replace(/^https?:\/\//i, '').replace(/\/.*$/, '');
    const fill = (template, map) => template.replace(/\{(\w+)\}/g, (match, key) => (key in map ? map[key] : match));

    /** @param {string} raw @returns {string|null} a link that starts with https, '' for an empty value, null when it is not a link */
    const cleanUrl = (raw) => {
      const value = raw.trim();
      if (!value) return '';
      if (/^https?:\/\/[^\s.]+\.\S+$/i.test(value)) return value;
      if (/^[^\s/.]+(\.[^\s/.]+)+(\/\S*)?$/.test(value)) return 'https://' + value;
      return null;
    };

    class LeadForm extends HTMLElement {
      connectedCallback() {
        this.kind = this.dataset.kind || 'brief';
        this.draftKey = this.dataset.draft || 'estasoft.leadDraft';
        this.ok = this.querySelector('[data-lf-ok]');
        this.form = this.querySelector('form');
        this.joined = [];
        this.plus = null;
        if (this.ok) {
          this.showOk();
          return;
        }
        if (!this.form) return;

        this.form.noValidate = true;
        this.summary = this.querySelector('[data-lf-summary]');
        this.types = Array.from(this.querySelectorAll('[data-lf-type]'));
        this.sets = Array.from(this.querySelectorAll('[data-lf-set]'));
        this.attached = this.querySelector('[data-lf-attached]');

        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        this.form.addEventListener('input', (event) => this.onField(event));
        this.form.addEventListener('change', (event) => this.onChange(event));
        this.pageshow = (event) => {
          if (event.persisted) this.reset();
        };
        window.addEventListener('pageshow', this.pageshow);
        if (this.summary) this.summary.addEventListener('click', (event) => this.onSummaryClick(event));

        const add = this.querySelector('[data-lf-add-link]');
        if (add) add.addEventListener('click', () => this.addLink(add));
        const detach = this.querySelector('[data-lf-detach]');
        if (detach) detach.addEventListener('click', () => this.detach());

        /* Boxes ticked at first are ticked here, not in the markup: without JavaScript every type's field set is sent. */
        this.form.querySelectorAll('[data-lf-default]').forEach((box) => {
          if (box instanceof HTMLInputElement) box.checked = true;
        });

        const serverErrors = Boolean(this.querySelector('[data-lf-server]'));
        if (serverErrors) this.restore();
        this.initType();
        if (serverErrors && this.summary) window.requestAnimationFrame(() => this.summary.focus());
      }

      /* ---------- project type ---------- */

      disconnectedCallback() {
        if (this.pageshow) window.removeEventListener('pageshow', this.pageshow);
      }

      initType() {
        if (!this.types.length) return;
        const params = new URLSearchParams(window.location.search);
        const wanted = params.get('type') || (params.get('from') === 'plus-check' ? 'plus' : '');
        const match = wanted ? this.types.find((radio) => radio.dataset.lfType === wanted) : null;
        if (match) match.checked = true;
        this.applySets();
        if (params.get('from') === 'plus-check') this.initAttached();
      }

      applySets() {
        const active = this.types.find((radio) => radio.checked);
        const key = active ? active.dataset.lfType : '';
        this.sets.forEach((set) => {
          set.disabled = set.dataset.lfSet !== key;
        });
        this.dataset.type = key;
      }

      /* ---------- answers from the Plus readiness check ---------- */

      initAttached() {
        if (!this.attached) return;
        const data = store.get('estasoft.plusCheck');
        if (!data || !data.summary) return;
        const text = this.attached.querySelector('[data-lf-attached-text]');
        const input = this.attached.querySelector('[data-lf-attached-input]');
        if (text) text.textContent = fill(text.dataset.template || '', { result: data.title, count: String(data.count) });
        if (input) {
          input.value = data.summary;
          input.disabled = false;
        }
        this.plus = data;
        this.attached.hidden = false;
      }

      detach() {
        const input = this.attached && this.attached.querySelector('[data-lf-attached-input]');
        if (input) input.disabled = true;
        if (this.attached) this.attached.hidden = true;
        this.plus = null;
        const url = new URL(window.location.href);
        url.searchParams.delete('from');
        window.history.replaceState(null, '', url.pathname + url.search + url.hash);
        const next = this.attached && this.attached.closest('[data-lf-set]');
        const target = next && next.querySelector('select, input:not([type="hidden"])');
        if (target instanceof HTMLElement) target.focus();
      }

      /* ---------- checking ---------- */

      fields() {
        return Array.from(this.form.querySelectorAll('[data-lf-field]')).filter((el) => !el.matches(':disabled') && !el.closest('[hidden]'));
      }

      /** @param {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement} el @returns {string} the error text, or '' when the field is fine */
      check(el) {
        const message = el.dataset.lfMsg || '';
        const required = el.hasAttribute('data-lf-req');
        if (el instanceof HTMLInputElement && el.type === 'checkbox') return required && !el.checked ? message : '';
        const value = el.value.trim();
        if (!value) return required ? message : '';
        const kind = el.dataset.lfKind;
        if (kind === 'email' && !EMAIL.test(value)) return message;
        if (kind === 'url' && cleanUrl(value) === null) return el.dataset.lfMsgUrl || message;
        return '';
      }

      mark(el, message) {
        const err = document.getElementById(el.id + '-err');
        if (message) el.setAttribute('aria-invalid', 'true');
        else el.removeAttribute('aria-invalid');
        if (err) {
          const text = err.querySelector('span');
          if (text) text.textContent = message;
          err.hidden = !message;
        }
      }

      onSubmit(event) {
        this.applySets();
        const problems = this.fields().map((el) => ({ el, message: this.check(el) })).filter((item) => item.message);
        if (problems.length) {
          event.preventDefault();
          this.showProblems(problems);
          return;
        }
        this.clearErrors();
        this.fields().forEach((el) => {
          if (el.dataset.lfKind === 'url' && el.value.trim()) el.value = cleanUrl(el.value) || el.value;
        });
        this.saveDraft();
        this.joinGroups();
        this.setBusy(true);
      }

      showProblems(problems) {
        this.fields().forEach((el) => this.mark(el, ''));
        problems.forEach((item) => this.mark(item.el, item.message));
        if (!this.summary) {
          problems[0].el.focus();
          return;
        }
        const list = this.summary.querySelector('[data-lf-summary-list]');
        if (list) {
          list.textContent = '';
          problems.forEach((item) => {
            const li = document.createElement('li');
            const link = document.createElement('a');
            link.href = '#' + item.el.id;
            link.textContent = (item.el.dataset.lfLabel || '') + ': ' + (item.el.dataset.lfSum || lcfirst(item.message));
            li.appendChild(link);
            list.appendChild(li);
          });
        }
        this.setSummaryTitle(problems.length);
        this.summary.hidden = false;
        this.summary.focus();
      }

      setSummaryTitle(count) {
        const title = this.summary && this.summary.querySelector('[data-lf-summary-title]');
        if (!title) return;
        title.textContent = count === 1 ? this.dataset.titleOne || '' : (this.dataset.titleMany || '').replace('{count}', String(count));
      }

      clearErrors() {
        if (!this.form) return;
        this.form.querySelectorAll('[data-lf-field]').forEach((el) => this.mark(el, ''));
        if (this.summary) {
          const list = this.summary.querySelector('[data-lf-summary-list]');
          if (list) list.textContent = '';
          this.summary.hidden = true;
        }
      }

      onField(event) {
        const el = event.target;
        if (!(el instanceof HTMLElement) || !el.matches('[data-lf-field]') || el.getAttribute('aria-invalid') !== 'true') return;
        if (this.check(el)) return;
        this.mark(el, '');
        if (!this.summary) return;
        const link = this.summary.querySelector('a[href="#' + el.id + '"]');
        if (link && link.parentElement) link.parentElement.remove();
        const left = this.summary.querySelectorAll('[data-lf-summary-list] li').length;
        if (left) this.setSummaryTitle(left);
        else this.summary.hidden = true;
      }

      onChange(event) {
        const el = event.target;
        if (el instanceof HTMLElement && el.matches('[data-lf-type]')) {
          this.applySets();
          this.clearErrors();
          return;
        }
        this.onField(event);
      }

      onSummaryClick(event) {
        const link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
        if (!link) return;
        const target = document.getElementById((link.getAttribute('href') || '').slice(1));
        if (!(target instanceof HTMLElement)) return;
        event.preventDefault();
        target.focus();
        target.scrollIntoView({ block: 'center' });
      }

      /* ---------- sending ---------- */

      joinGroups() {
        this.form.querySelectorAll('[data-lf-group]').forEach((group) => {
          if (group.matches(':disabled') || (group.parentElement && group.parentElement.closest('fieldset:disabled'))) return;
          const boxes = Array.from(group.querySelectorAll('[data-lf-choice]'));
          const picked = boxes.filter((box) => box instanceof HTMLInputElement && box.checked).map((box) => box.getAttribute('data-lf-choice'));
          if (picked.length) {
            const joined = document.createElement('input');
            joined.type = 'hidden';
            joined.name = 'contact[' + group.getAttribute('data-lf-group') + ']';
            joined.value = picked.join(', ');
            joined.setAttribute('data-lf-joined', '');
            this.form.appendChild(joined);
          }
          boxes.forEach((box) => {
            if (box instanceof HTMLInputElement) {
              box.disabled = true;
              this.joined.push(box);
            }
          });
        });
      }

      setBusy(on) {
        const button = this.querySelector('[data-lf-submit]');
        this.form.classList.toggle('is-sending', on);
        if (on) this.form.setAttribute('aria-busy', 'true');
        else this.form.removeAttribute('aria-busy');
        const status = this.querySelector('[data-lf-status]');
        if (status) status.textContent = on ? this.dataset.sending || '' : '';
        if (!(button instanceof HTMLElement)) return;
        const label = button.querySelector('[data-lf-label]');
        if (on) {
          button.setAttribute('aria-busy', 'true');
          if (label) {
            button.setAttribute('data-label', label.textContent || '');
            label.textContent = this.dataset.sending || label.textContent;
          }
        } else {
          button.removeAttribute('aria-busy');
          if (label && button.hasAttribute('data-label')) label.textContent = button.getAttribute('data-label');
        }
      }

      /** Back or forward button: the page comes from the cache with the sending state. */
      reset() {
        this.form.querySelectorAll('[data-lf-joined]').forEach((node) => node.remove());
        this.joined.forEach((box) => {
          box.disabled = false;
        });
        this.joined = [];
        this.setBusy(false);
        this.applySets();
      }

      /* ---------- what was typed ---------- */

      role(name) {
        const el = this.form.querySelector('[data-lf-role="' + name + '"]:not(:disabled)');
        return el instanceof HTMLInputElement || el instanceof HTMLSelectElement ? el.value.trim() : '';
      }

      saveDraft() {
        const fields = {};
        const checks = {};
        Array.from(this.form.elements).forEach((el) => {
          if (!(el instanceof HTMLInputElement || el instanceof HTMLSelectElement || el instanceof HTMLTextAreaElement)) return;
          if (!el.name || el.name === 'form_type' || el.name === 'utf8' || el.type === 'hidden' || el.type === 'submit' || el.type === 'button') return;
          if (el.matches(':disabled')) return;
          if (el.type === 'checkbox') checks[el.name] = el.checked;
          else if (el.type === 'radio') {
            if (el.checked) fields[el.name] = el.value;
          } else fields[el.name] = el.value;
        });
        const type = this.types.find((radio) => radio.checked);
        store.set(this.draftKey, {
          f: fields,
          c: checks,
          type: type ? type.dataset.lfType : '',
          typeTitle: type ? type.dataset.title || '' : '',
          timeline: this.role('timeline'),
          url: this.role('url'),
          email: this.role('email'),
          plus: this.plus && this.attached && !this.attached.hidden ? { title: this.plus.title, count: this.plus.count } : null,
          savedAt: Date.now(),
        });
      }

      /** The saved draft, or null when there is none or it is older than 30 minutes (it is removed then). */
      readDraft() {
        const draft = store.get(this.draftKey);
        if (draft && draft.savedAt && Date.now() - draft.savedAt > 30 * 60 * 1000) {
          store.remove(this.draftKey);
          return null;
        }
        return draft;
      }

      /** After a server error the page is rendered again from scratch: put back what the visitor typed. */
      restore() {
        const draft = this.readDraft();
        if (!draft || !draft.f) return;
        Array.from(this.form.elements).forEach((el) => {
          if (!(el instanceof HTMLInputElement || el instanceof HTMLSelectElement || el instanceof HTMLTextAreaElement)) return;
          if (!el.name || el.type === 'hidden') return;
          if (el.type === 'radio') {
            if (draft.f[el.name] === el.value) el.checked = true;
          } else if (el.type === 'checkbox') {
            if (draft.c && el.name in draft.c) el.checked = Boolean(draft.c[el.name]);
          } else if (!el.value && draft.f[el.name]) el.value = draft.f[el.name];
        });
      }

      addLink(button) {
        const wrap = this.querySelector('[data-lf-links]');
        const more = this.querySelector('[data-lf-links-more]');
        if (!wrap || !more) return;
        const first = wrap.querySelector('input');
        const count = wrap.querySelectorAll('input').length;
        if (!first || count >= 3) return;
        const n = count + 1;
        const input = document.createElement('input');
        input.className = 'fld';
        input.type = 'url';
        input.name = 'contact[Link ' + n + ']';
        input.id = first.id + '-' + n;
        input.placeholder = first.placeholder;
        input.autocomplete = 'url';
        input.setAttribute('aria-label', (button.getAttribute('data-label-template') || '').replace('{n}', String(n)));
        input.setAttribute('data-lf-field', '');
        input.setAttribute('data-lf-kind', 'url');
        input.setAttribute('data-lf-label', first.getAttribute('data-lf-label') || '');
        input.setAttribute('data-lf-msg-url', first.getAttribute('data-lf-msg-url') || '');
        const err = first.parentElement ? first.parentElement.querySelector('[data-lf-err]') : null;
        const holder = document.createElement('div');
        holder.className = 'lf-f';
        holder.appendChild(input);
        if (err) {
          const copy = err.cloneNode(true);
          copy.id = input.id + '-err';
          copy.hidden = true;
          input.setAttribute('aria-describedby', copy.id);
          holder.appendChild(copy);
        }
        more.appendChild(holder);
        input.focus();
        if (n >= 3) {
          button.hidden = true;
        }
      }

      /* ---------- after sending ---------- */

      showOk() {
        const draft = this.readDraft();
        const ok = this.ok;
        const text = ok.querySelector('[data-lf-ok-text]');
        const template = text ? text.dataset.template || '' : '';
        if (draft) {
          if (this.kind === 'brief') {
            const next = Array.from(ok.querySelectorAll('[data-lf-ok-next]')).find((el) => el.getAttribute('data-lf-ok-next') === draft.type);
            const generic = ok.querySelector('[data-lf-ok-next="generic"]');
            if (next instanceof HTMLElement) {
              if (generic instanceof HTMLElement) generic.hidden = true;
              next.hidden = false;
              if (text && template) text.textContent = fill(template, { owner: next.dataset.owner || '', reply: next.dataset.reply || '' });
            }
            this.fillRows(draft);
          } else if (text && template) {
            text.textContent = fill(template, {
              store: draft.url ? hostOf(draft.url) : text.dataset.fallbackStore || '',
              email: draft.email || text.dataset.fallbackEmail || '',
            });
          }
          if (draft.plus) store.remove('estasoft.plusCheck');
        }
        store.remove(this.draftKey);
      }

      fillRows(draft) {
        const box = this.ok.querySelector('[data-lf-ok-rows]');
        if (!box) return;
        const rows = [[box.dataset.labelType, draft.typeTitle], [box.dataset.labelTimeline, draft.timeline]];
        if (draft.plus) rows.push([box.dataset.labelPlus, fill(box.dataset.plusTemplate || '', { result: draft.plus.title, count: String(draft.plus.count) })]);
        rows.forEach((row) => {
          if (!row[0] || !row[1]) return;
          const line = document.createElement('div');
          line.className = 'lf-ok-row';
          const key = document.createElement('div');
          key.className = 'lf-ok-k';
          key.textContent = row[0];
          const value = document.createElement('div');
          value.className = 'lf-ok-v';
          value.textContent = row[1];
          line.append(key, value);
          box.appendChild(line);
        });
        box.hidden = box.childElementCount === 0;
      }
    }
    customElements.define('lead-form', LeadForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sup-form"] && !Shopify.designMode) return;
  try {
    /* Support request form: product from ?product=, checks in the browser, sending state, draft kept across a reload. */
  if (!customElements.get('support-request')) {
    class SupportRequest extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.card = this.querySelector('[data-sup-card]');
        if (!this.form || !this.card) return;
        this.draftKey = 'estasoft-support-draft';
        if (this.card.hasAttribute('data-posted')) {
          this.clearDraft();
          return;
        }
        this.fields = {};
        this.querySelectorAll('[data-sup-field]').forEach((el) => { this.fields[el.dataset.supField] = el; });
        this.errs = {};
        this.querySelectorAll('[data-sup-err]').forEach((el) => { this.errs[el.dataset.supErr] = el; });
        this.summary = this.querySelector('[data-sup-summary]');
        this.failed = this.querySelector('[data-sup-failed]');
        this.sending = this.querySelector('[data-sup-sending]');
        this.strip = this.querySelector('[data-sup-strip]');
        this.subject = this.querySelector('[data-sup-subject]');
        this.submit = this.querySelector('[data-sup-submit]');
        this.submitLabel = this.querySelector('[data-sup-submit-label]');
        this.spin = this.querySelector('[data-sup-spin]');
        this.arrow = this.querySelector('[data-sup-arrow]');
        this.idleLabel = this.submitLabel ? this.submitLabel.textContent : '';
        this.preselected = '';
        this.timer = null;

        this.form.noValidate = true;
        this.form.addEventListener('submit', (e) => this.onSubmit(e));
        this.form.addEventListener('input', (e) => this.onInput(e));
        this.form.addEventListener('change', (e) => this.onChange(e));
        this.pageshow = (e) => { if (e.persisted) this.reset(); };
        window.addEventListener('pageshow', this.pageshow);
        /* leaving the page (the captcha page or the answer) ends the wait */
        this.pagehide = () => clearTimeout(this.timer);
        window.addEventListener('pagehide', this.pagehide);

        if (this.card.hasAttribute('data-has-errors')) this.restoreDraft();
        this.preselectFromUrl();
        this.updateSubject();
        if (this.summary && !this.summary.hidden) this.focusAlert(this.summary);
        else if (this.failed && !this.failed.hidden) this.focusAlert(this.failed);
      }

      disconnectedCallback() {
        if (this.pageshow) window.removeEventListener('pageshow', this.pageshow);
        if (this.pagehide) window.removeEventListener('pagehide', this.pagehide);
        clearTimeout(this.timer);
      }

      focusAlert(el) {
        window.requestAnimationFrame(() => { try { el.focus(); } catch (err) { /* ignore */ } });
      }

      /* ?product=<handle> chooses the product and shows the quick answers */
      preselectFromUrl() {
        const select = this.fields.product;
        if (!select) return;
        let handle = '';
        try { handle = (new URLSearchParams(window.location.search).get('product') || '').trim().toLowerCase(); } catch (err) { handle = ''; }
        if (!handle || select.value) return;
        const option = Array.from(select.options).find((o) => o.dataset.handle && o.dataset.handle.toLowerCase() === handle);
        if (!option) return;
        select.value = option.value;
        this.preselected = option.value;
        this.showStrip(option);
      }

      showStrip(option) {
        if (!this.strip) return;
        const title = this.strip.querySelector('[data-sup-strip-title]');
        const template = this.dataset.stripTitle || '';
        if (title) title.textContent = template.indexOf('{product}') > -1 ? template.replace('{product}', option.textContent.trim()) : (template || option.textContent.trim());
        const handle = (option.dataset.handle || '').toLowerCase();
        const list = this.strip.querySelector('[data-sup-qa]');
        if (list) {
          let shown = 0;
          list.querySelectorAll('li').forEach((li) => {
            const only = (li.dataset.handle || '').toLowerCase();
            const show = !only || only === handle;
            li.hidden = !show;
            if (show) shown += 1;
          });
          list.hidden = shown === 0;
        }
        this.strip.hidden = false;
      }

      /* Shopify's contact email has a fixed subject, so the product goes into a Subject line of the message */
      updateSubject() {
        if (!this.subject) return;
        const base = this.dataset.subject || '';
        const select = this.fields.product;
        const name = select && select.value ? select.value : '';
        this.subject.value = name ? (base ? base + ': ' + name : name) : base;
      }

      onChange(e) {
        const el = e.target;
        if (el === this.fields.product) {
          this.updateSubject();
          if (this.strip) {
            if (this.preselected && el.value === this.preselected) this.showStrip(el.selectedOptions[0]);
            else this.strip.hidden = true;
          }
          this.revalidateField('product');
        }
      }

      onInput(e) {
        const key = e.target && e.target.dataset ? e.target.dataset.supField : '';
        if (key) this.revalidateField(key);
      }

      /* clear a field's message as soon as it is fixed */
      revalidateField(key) {
        const el = this.fields[key];
        if (!el || el.getAttribute('aria-invalid') !== 'true') return;
        if (this.isValid(key)) {
          this.setInvalid(key, false);
          this.refreshSummary();
        }
      }

      isValid(key) {
        const el = this.fields[key];
        if (!el) return true;
        const v = (el.value || '').trim();
        if (key === 'email') return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
        if (key === 'name' || key === 'body' || key === 'product') return v !== '';
        return true;
      }

      setInvalid(key, on) {
        const el = this.fields[key];
        const err = this.errs[key];
        if (!el) return;
        if (on) {
          el.setAttribute('aria-invalid', 'true');
          if (err) { el.setAttribute('aria-describedby', err.id); err.hidden = false; }
        } else {
          el.removeAttribute('aria-invalid');
          el.removeAttribute('aria-describedby');
          if (err) err.hidden = true;
        }
      }

      invalidKeys() {
        return ['name', 'email', 'product', 'body'].filter((k) => this.fields[k] && this.fields[k].getAttribute('aria-invalid') === 'true');
      }

      refreshSummary() {
        if (!this.summary) return;
        const keys = this.invalidKeys();
        if (!keys.length) { this.summary.hidden = true; return; }
        const title = this.summary.querySelector('[data-sup-summary-title]');
        const list = this.summary.querySelector('[data-sup-summary-list]');
        const text = keys.length === 1 ? this.dataset.titleOne : (this.dataset.titleMany || '').replace('{count}', String(keys.length));
        if (title) title.textContent = text;
        if (list) {
          list.textContent = '';
          keys.forEach((k) => {
            const el = this.fields[k];
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = '#' + el.id;
            a.textContent = (el.dataset.label || '') + ': ' + (el.dataset.short || '');
            a.addEventListener('click', (ev) => { ev.preventDefault(); el.focus(); });
            li.appendChild(a);
            list.appendChild(li);
          });
        }
        this.summary.hidden = false;
      }

      validate() {
        let first = null;
        ['name', 'email', 'product', 'body'].forEach((k) => {
          if (!this.fields[k]) return;
          const bad = !this.isValid(k);
          this.setInvalid(k, bad);
          if (bad && !first) first = k;
        });
        return first;
      }

      onSubmit(e) {
        if (this.card.dataset.state === 'sending') { e.preventDefault(); return; }
        const first = this.validate();
        if (first) {
          e.preventDefault();
          if (this.failed) this.failed.hidden = true;
          this.setState('errors');
          this.refreshSummary();
          if (this.summary) this.focusAlert(this.summary);
          return;
        }
        if (this.summary) this.summary.hidden = true;
        this.updateSubject();
        this.saveDraft();
        this.setState('sending');
        /* only the send button is locked, after the browser has collected the values */
        window.setTimeout(() => this.lock(true), 0);
        /* no answer after 2 minutes: unlock and say it could not be sent. Long enough for a captcha check. */
        this.timer = window.setTimeout(() => this.fail(), 120000);
      }

      setState(state) {
        this.card.dataset.state = state;
        const sending = state === 'sending';
        if (this.sending) this.sending.hidden = !sending;
        if (sending && this.failed) this.failed.hidden = true;
        if (this.submit) {
          if (sending) this.submit.setAttribute('aria-busy', 'true'); else this.submit.removeAttribute('aria-busy');
        }
        if (this.spin) this.spin.hidden = !sending;
        if (this.arrow) this.arrow.hidden = sending;
        if (this.submitLabel) {
          if (sending) this.submitLabel.textContent = this.dataset.sendingLabel || this.idleLabel;
          else if (state === 'failed') this.submitLabel.textContent = this.dataset.retryLabel || this.idleLabel;
          else this.submitLabel.textContent = this.idleLabel;
        }
      }

      /* Fields are never disabled: a form that is submitted again (for example after a captcha check) would leave them out. */
      lock(on) {
        if (!this.submit) return;
        this.submit.disabled = on;
        if (on) this.submit.setAttribute('aria-disabled', 'true'); else this.submit.removeAttribute('aria-disabled');
      }

      fail() {
        this.lock(false);
        this.setState('failed');
        if (this.failed) { this.failed.hidden = false; this.focusAlert(this.failed); }
      }

      reset() {
        clearTimeout(this.timer);
        this.lock(false);
        this.setState('idle');
      }

      /* keep what was typed, so a failed send does not lose it */
      saveDraft() {
        try {
          const data = {};
          Object.keys(this.fields).forEach((k) => { data[k] = this.fields[k].value; });
          const topic = this.form.querySelector('input[data-sup-topic]:checked');
          data.topic = topic ? topic.value : '';
          data.savedAt = Date.now();
          window.sessionStorage.setItem(this.draftKey, JSON.stringify(data));
        } catch (err) { /* storage can be blocked */ }
      }

      restoreDraft() {
        try {
          const raw = window.sessionStorage.getItem(this.draftKey);
          if (!raw) return;
          const data = JSON.parse(raw);
          /* a draft older than 30 minutes is dropped */
          if (data.savedAt && Date.now() - data.savedAt > 30 * 60 * 1000) { this.clearDraft(); return; }
          Object.keys(this.fields).forEach((k) => {
            const el = this.fields[k];
            if (!el.value && data[k]) el.value = data[k];
          });
          if (data.topic) {
            const radio = Array.from(this.form.querySelectorAll('input[data-sup-topic]')).find((r) => r.value === data.topic);
            if (radio) radio.checked = true;
          }
        } catch (err) { /* ignore */ }
      }

      clearDraft() {
        try { window.sessionStorage.removeItem(this.draftKey); } catch (err) { /* ignore */ }
      }
    }
    customElements.define('support-request', SupportRequest);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["svc-pic"] && !Shopify.designMode) return;
  try {
    (function () {
    function fit(el) {
      el.style.setProperty('--pf', '1');
      var ps = parseFloat(getComputedStyle(el).getPropertyValue('--ps')) || 1;
      var natural = 460 * ps;
      var avail = el.getBoundingClientRect().width;
      var f = avail > 0 && avail < natural ? avail / natural : 1;
      el.style.setProperty('--pf', f.toFixed(4));
    }
    function init() {
      var list = document.querySelectorAll('.svp');
      for (var i = 0; i < list.length; i++) {
        (function (el) {
          fit(el);
          if (window.ResizeObserver && el.parentElement) {
            new ResizeObserver(function () { fit(el); }).observe(el.parentElement);
          } else {
            window.addEventListener('resize', function () { fit(el); });
          }
        })(list[i]);
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
